import React from "react";
import {  useNavigate } from "react-router-dom";
import Navbar from "./navbar";
import { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import './App.css';

export default function Newloan() {
  
  const API_URL = process.env.REACT_APP_WEB_API_KEY;

    var date = new Date().toISOString().slice(0,10);
  
    const edate = new Date();
    const enddate = new Date(edate.getTime());
    enddate.setDate(edate.getDate() + 100);
    const closingDate = enddate.toISOString().slice(0,10)
    
    const navigate = useNavigate();
    const location = useLocation()
    const{cusid,cusname,place,custom,setting} = location.state;
    const[iloanno, setIloanno]= useState([]);
    const [settings, setSettings] = useState([]);
    const userid = parseInt(localStorage.getItem("userid")) ;
    const [account, setAccount] = useState([]);
    const [loanstatus,setLoanstatus] = useState([]);
    const [dialogNo,setDialogNo] = useState(0);
    const [accnum, setAccnum] = useState([]);
    const [customerlist,setCustomerlist] = useState([]);
    var acno = setting.length > 0 ?setting[0].LoanID+1 : 1;
    
    
console.log(cusid);


useEffect(()=>{
  fetch(API_URL+"api/Interest/GetLoanno")
  .then(res=>res.json())
  .then((data)=>{setIloanno(data);});

  fetch(API_URL+"api/ReceiptKey/GetCommonSettings")
  .then(res=>res.json())
  .then((data)=>{setSettings(data)});

  fetch(API_URL+"api/Userloan/GetLoanStatus?userid="+userid)
  .then(response => response.json())
  .then(data => {setLoanstatus(data)});

  fetch(API_URL+"api/Ledger/GetAccounts")
  .then(response => response.json())
  .then(data => {setAccount(data)});

  fetch(API_URL+"api/Loan/GetLoanForAccNo")
  .then(response => response.json())
  .then(data => {setAccnum(data)});

  fetch(API_URL+"api/Customer/CustomerList")
  .then(response => response.json())
  .then(data => {setCustomerlist(data)});
        

},[])

console.log(iloanno);

function sleep(ms)
{
  return new Promise(resolve => setTimeout(resolve, ms));
}


function createloan()
{
  var accno = document.getElementById('accountnumber').value.toUpperCase();
  var ldate = document.getElementById('doloan').value;
  var tol = document.getElementById('loantype').value;
  var lamount = document.getElementById('lAmount').value;
  var lint = document.getElementById('iRate').value;
  var install = document.getElementById('duration').value;
  var instamount = document.getElementById('lAmount').value/100;
  var instpaid = 0;
  var lbal = document.getElementById('lAmount').value;
  var cldate = document.getElementById('clDate').value;
  var intamount = document.getElementById('inttaken').value;
  var docfee = document.getElementById('docfee').value;
  var cid = cusid;
  var commonid = settings[0].CommonID + 1;
  var loanno = settings[0].LoanID + 1;
  var interesttransid= settings[0].IntTransID + 1;
  var guarantorid = document.getElementById('guarantor').value;
  
  console.log(ldate);

  if (loanstatus.length !== 0 )
  {
      if(loanstatus[0].LoanReturned === 1)
      {
        setDialogNo(1);
        showOKdialog();
      }
      else if(date < loanstatus[0].EntryDate.slice(0,10))
      {
        setDialogNo(2);
        showOKdialog();
      }
      else if(loanstatus[0].ForDate.slice(0,10) > date)
      {
        setDialogNo(3);
        showOKdialog();
      }
      else if(loanstatus[0].ForDate.slice(0,10) < date)
      {
        setDialogNo(4);
        showOKdialog();
      }
      else 
      {

        const yes = accnum.filter(el => {if(el.AccountNo === accno){ return el }})
        if (yes.length > 0 )
        {
            alert("sorry! Account Number has been assigned already to another Customer");
        }
        else{
        const data = new FormData();
        data.append("lno",loanno);
        data.append("accountnumber",accno);
        data.append("ldate",ldate);
        data.append("tol",tol);
        data.append("lamount",lamount);
        data.append("lint", lint);
        data.append("install",install);
        data.append("instamount",instamount);
        data.append("instpaid",instpaid);
        data.append("lbal",lbal);
        data.append("cldate",cldate);
        data.append("intamount",intamount);
        data.append("docfee",docfee);
        data.append("cid",cid);
        data.append("userid",userid);
        data.append("commonid",commonid);
        data.append("guarantorid",guarantorid);

        fetch(API_URL+"api/Loan/CreateLoan",{method:"POST",body:data})
        .then(res=>res.json())
        .then(()=>{})

        fetch(API_URL+"api/Ledger/UpdateLoanID?id="+ loanno,{method:"PUT",body:null})
        .then(response=>response.json())
        .then(()=>{});  


        const interest = new FormData();
        interest.append("ldate",ldate);
        interest.append("tol",tol);
        interest.append("intamount",intamount);
        interest.append("loanno",loanno);
        interest.append("accountnumber",accno);
        interest.append("userid",userid);
        interest.append("commonid",commonid);
        interest.append("transid",interesttransid)
  
        fetch(API_URL+"api/Interest/CreateInterest",{method:"POST",body:interest})
        .then(res=>res.json())
        .then(()=>{})
    
        fetch(API_URL+"api/Ledger/UpdateIntTransID?id="+ interesttransid,{method:"PUT",body:null})
        .then(response=>response.json())
        .then(()=>{});

        setDialogNo(5);
        showOKdialog();
        }

      }
  }
  else
  {
    setDialogNo(6);
    showOKdialog();
  }
}

function ledgerentry()
{

    const amount = parseFloat(document.getElementById('lAmount').value);
    var transid = settings[0].AccTransID + 1;
    const commonid = settings[0].CommonID + 1


    const loanaccount = account.filter((e)=>{if(e.AccountID === 4){return e;}})
    const loanaccbalance = (loanaccount[0].CurrentDebit+amount)-loanaccount[0].CurrentCredit;
    
    const loanaccountdata = new FormData();
    loanaccountdata.append("entrydate",date);
    loanaccountdata.append("accountdate",date)
    loanaccountdata.append("accountid",loanaccount[0].AccountID)
    loanaccountdata.append("description", "By Cash Account Loan NO"+(settings[0].LoanID + 1) );
    loanaccountdata.append("refnumber",("L.NO "+(settings[0].LoanID + 1)));
    loanaccountdata.append("vouchertype",1);
    loanaccountdata.append("vouchernum",1);
    loanaccountdata.append("dramount",amount);
    loanaccountdata.append("cramount",0);
    loanaccountdata.append("balance",loanaccbalance);
    loanaccountdata.append("transid",transid);
    loanaccountdata.append("commonid",commonid);
    loanaccountdata.append("userid",userid);

    fetch(API_URL+"api/Ledger/EnterLedger",{method:"POST",body:loanaccountdata})
    .then(response=>response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentDebit?id="+loanaccount[0].AccountID+"&amount="+(loanaccount[0].CurrentDebit + amount),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});

    
    const cashaccount = account.filter((e)=>{if(e.AccountID === 3){return e;}})
    var cashbalance = cashaccount[0].CurrentDebit - (cashaccount[0].CurrentCredit + parseFloat(amount));
    transid = transid + 1;

    loanaccountdata.set("accountid",cashaccount[0].AccountID)
    loanaccountdata.set("balance",cashbalance);
    loanaccountdata.set("transid",transid);
    loanaccountdata.set("dramount",0);
    loanaccountdata.set("cramount",amount);
    loanaccountdata.set("description","To Loan Account Loan NO"+(settings[0].LoanID + 1));


    // const cashaccountdata = new FormData();
    
    // cashaccountdata.append("entrydate",date);
    // cashaccountdata.append("accountdate",date)
    // cashaccountdata.append("accountid",cashaccount[0].AccountID)
    // cashaccountdata.append("description", "To Loan Amount "+ (settings[0].LoanID + 1));
    // cashaccountdata.append("refnumber",("L.NO "+settings[0].LoanID + 1));
    // cashaccountdata.append("vouchertype",1);
    // cashaccountdata.append("vouchernum",1);
    // cashaccountdata.append("dramount",0);
    // cashaccountdata.append("cramount",amount);
    // cashaccountdata.append("balance",cashbalance);
    // cashaccountdata.append("transid",transid);
    // cashaccountdata.append("commonid",commonid);
    // cashaccountdata.append("userid",userid);
    
    fetch(API_URL+"api/Ledger/EnterLedger",{method:"POST",body:loanaccountdata})
    .then(response=>response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentCredit?id="+cashaccount[0].AccountID+"&amount="+(cashaccount[0].CurrentCredit + amount),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});

    
    //iNTEREST ACCOUNT LEDGER ENTRY
    
    const interestamount =parseFloat( document.getElementById('inttaken').value);
    var cashbalance = (cashaccount[0].CurrentDebit + interestamount) - (cashaccount[0].CurrentCredit + amount);
    transid = transid + 1;

    const interestAccountdata = new FormData();
    interestAccountdata.append("entrydate",date);
    interestAccountdata.append("accountdate",date)
    interestAccountdata.append("accountid",cashaccount[0].AccountID)
    interestAccountdata.append("description", "By Interest Account Loan No " + (settings[0].LoanID + 1));
    interestAccountdata.append("refnumber",("L.NO "+(settings[0].LoanID + 1)));
    interestAccountdata.append("vouchertype",1);
    interestAccountdata.append("vouchernum",1);
    interestAccountdata.append("dramount",interestamount);
    interestAccountdata.append("cramount",0);
    interestAccountdata.append("balance",cashbalance);
    interestAccountdata.append("transid",transid);
    interestAccountdata.append("commonid",commonid);
    interestAccountdata.append("userid",userid);

    fetch(API_URL+"api/Ledger/EnterLedger",{method:"POST",body:interestAccountdata})
    .then(response=>response.json())
    .then(()=>{});
    

    transid = transid + 1;
    const interestaccount = account.filter((e)=>{if(e.AccountID === 5){return e;}})
    const interestaccbalance = interestaccount[0].CurrentDebit -(interestaccount[0].CurrentCredit+interestamount);
    
    interestAccountdata.set("accountid",interestaccount[0].AccountID)
    interestAccountdata.set("balance",interestaccbalance);
    interestAccountdata.set("transid",transid);
    interestAccountdata.set("dramount",0);
    interestAccountdata.set("cramount",interestamount);
    interestAccountdata.set("description", "To Cash Account Loan No " + (settings[0].LoanID + 1));

    fetch(API_URL+"api/Ledger/EnterLedger",{method:"POST",body:interestAccountdata})
    .then(response=>response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentCredit?id="+interestaccount[0].AccountID+"&amount="+(interestaccount[0].CurrentCredit+interestamount),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});

    // fetch(API_URL+"api/Ledger/UpdateCurrentDebit?id="+cashaccount[0].AccountID+"&amount="+cashaccount[0].CurrentDebit + parseFloat(interestamount),{method:"PUT",body:null})
    // .then(response => response.json())
    // .then(()=>{});

    // DOCUMNET FEE LEDGER ENTRY

    const documentamount = parseFloat(document.getElementById('docfee').value);
    
    var cashbalance = (cashaccount[0].CurrentDebit + parseFloat(interestamount)+parseFloat(documentamount)) - (cashaccount[0].CurrentCredit + amount);
    transid = transid + 1;

    const documentAccountdata = new FormData();
    documentAccountdata.append("entrydate",date);
    documentAccountdata.append("accountdate",date)
    documentAccountdata.append("accountid",cashaccount[0].AccountID)
    documentAccountdata.append("description", "By Document Account Loan No " + "("+(settings[0].LoanID + 1)+")");
    documentAccountdata.append("refnumber",("L.NO "+(settings[0].LoanID + 1)));
    documentAccountdata.append("vouchertype",1);
    documentAccountdata.append("vouchernum",1);
    documentAccountdata.append("dramount",documentamount);
    documentAccountdata.append("cramount",0);
    documentAccountdata.append("balance",cashbalance);
    documentAccountdata.append("transid",transid);
    documentAccountdata.append("commonid",commonid);
    documentAccountdata.append("userid",userid);

    fetch(API_URL+"api/Ledger/EnterLedger",{method:"POST",body:documentAccountdata})
    .then(response=>response.json())
    .then(()=>{});
    
    const documentaccount = account.filter((e)=>{if(e.AccountID === 7){return e;}})
    const documentaccbalance = documentaccount[0].CurrentDebit - (documentaccount[0].CurrentCredit+documentamount);
    transid = transid + 1;

    documentAccountdata.set("accountid",documentaccount[0].AccountID)
    documentAccountdata.set("balance",documentaccbalance);
    documentAccountdata.set("transid",transid);
    documentAccountdata.set("dramount",0);
    documentAccountdata.set("cramount",documentamount);
    documentAccountdata.set("description", "To Cash Account Loan No " + "("+(settings[0].LoanID + 1)+")");

    fetch(API_URL+"api/Ledger/EnterLedger",{method:"POST",body:documentAccountdata})
    .then(response=>response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentCredit?id="+documentaccount[0].AccountID+"&amount="+(documentaccount[0].CurrentCredit+documentamount),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentDebit?id="+cashaccount[0].AccountID+"&amount="+(cashaccount[0].CurrentDebit + interestamount+documentamount),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});
    
    
    fetch(API_URL+"api/Ledger/UpdateAccTransID?id="+transid,{method:"PUT",body:null})
    .then(response=>response.json())
    .then(()=>{});


    const loanledgerdata = new FormData();
    const loantransid = settings[0].LoanTransID + 1;
    var loanno = settings[0].LoanID + 1;
    var accno = document.getElementById('accountnumber').value.toUpperCase();

    loanledgerdata.append("entrydate",date);
    loanledgerdata.append("description", "To Loan Amount  Loan No " + "("+loanno+")");
    loanledgerdata.append("dramount",0);
    loanledgerdata.append("cramount",amount);
    loanledgerdata.append("balance",amount);
    loanledgerdata.append("transid",loantransid);
    loanledgerdata.append("commonid",commonid);
    loanledgerdata.append("loanno",loanno);
    loanledgerdata.append("accountnumber",accno);
    loanledgerdata.append("userid",userid);

    fetch(API_URL+"api/Ledger/LoanLedgerEntry",{method:"POST",body:loanledgerdata})
    .then(response=>response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateLoanTransID?id="+loantransid,{method:"PUT",body:null})
    .then(response=>response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCommonID?id="+commonid,{method:"PUT",body:null})
    .then(response=>response.json())
    .then(()=>{});

}

function showOKdialog()
{
  const dialog = document.getElementById('myDialog');
  dialog.showModal();
}

function validate(){
  if(document.getElementById('accountnumber').value ==='' || document.getElementById('guarantor').value === ''||
  document.getElementById('duration').value===''|| document.getElementById('lAmount').value==='' ||
  document.getElementById('iRate').value===''||document.getElementById('docfee').value==='')
  {
    alert("Feilds Cannot be empty"); 
  } 
  else
  {
    
     return true;
  }
}


    return (
        <>
        <div style={{
        backgroundColor:"blue", 
        color:"white", 
        height:"40px", 
        width:"100%", 
        padding:"5px", 
        position:"relative", 
        fontFamily:"sans-serif",
        fontSize:"20px"}}> Loan
                <Navbar/>
      </div>      
      <div style={{backgroundColor:"goldenrod",height:"25px",width:"100%",textAlign:"center",zIndex:-1}}>New Loan</div>
      
      <div style = {{top:"10px", position:"relative",color:"black",  padding:-1, width:"100%"}}>
      <form>
      <label for="cName" style={{marginLeft:"15px"}}>CustomerName</label><br/>
      <input type = "text" id = 'cName' value = {cusname} style = {{marginLeft:"4%",height:"30px",width:"90%",textAlign:"center"}} readOnly></input>
      <fieldset >
      <legend>Loan Info</legend>
      
      <label for = 'accountnumber'>Account Number</label><br/>
      <input type = "text" id = 'accountnumber' defaultValue= {acno} className='inputfield'></input><br/><br/>
     
      <label for = "guarantor">Guarantor ID</label>
      <label for = 'doloan' style ={{float:"right",marginRight:"3%"}}>Date Of Loan </label><br/>
      <input id = "guarantor" type = 'text' defaultValue = "0" style = {{height:"30px",width:"29%",marginLeft:"1%"}}></input>
      
      <select id = 'gid' style={{width:"30px",height:"30px"}} onChange={(e)=>{return(document.getElementById('guarantor').value = e.target.value)}}>
        <option value = "0"></option>
        {customerlist.map(cus => {return(<option value={cus.CustomerID}>{cus.CustomerID},{cus.CustomerName},{cus.Address},{cus.MobileNumber}</option>) })}
        </select>
      <input id = 'doloan' type = "date"  Value = {new Date().toISOString().slice(0,10)} style = {{height:"30px",width:"40%",marginLeft:"17%"}} readOnly/><br/><br/>
      
      
      <label for = "loantype">Type Of Loan</label>
      <label for ="duration" style ={{float:"right",marginRight:"3%"}}>Duration</label><br/>
      <input id = "loantype" type = 'text' value = "Daily" style = {{height:"30px",width:"39%",marginLeft:"1%"}}></input>
      <input id = "duration" defaultValue = "100" type = 'text' style = {{height:"30px",width:"40%",marginLeft:"14%"}}></input><br /><br/>
      
      <label for ="lAmount">Loan Amount</label>
      <label for ='iRate' style ={{float:"right",marginRight:"3%"}}>Interest Rate</label><br />
      <input type='text' id='lAmount' style={{ height: "30px", width: "39%",marginLeft:"1%" }} onChange={(e) => { return ((document.getElementById('inttaken').value = e.target.value * document.getElementById('iRate').value / 100),
        (document.getElementById('disamt').value = e.target.value-document.getElementById('inttaken').value-document.getElementById('docfee').value)) }}></input>
        <input id='iRate' type='text' style={{ height: "30px", width: "40%", marginLeft: "14%" }} onChange={(e) => { return ((document.getElementById('inttaken').value = document.getElementById('lAmount').value * e.target.value / 100),
        (document.getElementById('disamt').value = document.getElementById('lAmount').value-document.getElementById('inttaken').value-document.getElementById('docfee').value)) }} /> <br /><br />
      
      <label for = "clDate">Closing Date</label><br/>
      <input type = "date" id ="clDate" value = {closingDate} className='inputfield' readOnly></input><br/><br/>
      
      <label for ="inttaken">Interest Taken</label>
      <input type = 'text' id ='inttaken' Value = "0" className='inputfield' readOnly ></input><br/><br/>
      
      <label for ='docfee'>Document Fee</label><br/>
      <input id = 'docfee' type = 'text' defaultValue='10' className='inputfield' onChange= {()=>{
         return(document.getElementById('disamt').value = document.getElementById('lAmount').value-document.getElementById('inttaken').value-document.getElementById('docfee').value)
         }}></input><br/><br/>
      
      <label for ='disamt'>Final Amount</label><br/>
      <input id = 'disamt' value = "0" type ='text' className='inputfield' readOnly></input>
      
      
      </fieldset>
      <div style={{marginBottom:"20%"}}>
      <button type = "button"  className="actionbuttons" onClick={()=>{if(validate()){createloan();}}}>Loan</button>
      <button type = "button"  className="actionbuttons" style ={{backgroundColor:"red"}} onClick ={ () => {navigate("/actions",{state:{cusid,cusname,place,custom}})}}>Back</button>
      </div>
      
      </form>
      </div>
      {/*<dialog id="myDialog" className="okdialog"><p>Loan Creation Successful</p>
            <button className="okdialogbutton" onClick={()=>{ledgerentry(); navigate("/actions",{state:{cusid,cusname,place,custom}});}}>OK</button>
        </dialog>*/}
      <dialog id="myDialog" className="okdialog">
            {dialogNo === 1 ? <>
            <p>Loan Distripution Closed For this User ID : {userid}  </p>
            <button className="okdialogbutton" onClick={()=>{navigate('/home')}}>OK</button> </> : <></>}
            {dialogNo === 2 ? <>
            <p>Please Make Sure, Loan Date is Correct</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/home')}}>OK</button> </> : <></>}
            {dialogNo === 3 ? <>
            <p>Sorry! You Can't Make Loan for Today's Date As Your Day closed</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/home')}}>OK</button> </> : <></>}
            {dialogNo === 4 ? <>
            <p>Sorry! Please Make Sure Last Day Collection Settlement is Over</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/home')}}>OK</button> </> : <></>}
            {dialogNo === 5 ? <>
            <p>Loan Creation Successful</p>
            <button className="okdialogbutton" onClick={()=>{ledgerentry();navigate("/actions",{state:{cusid,cusname,place,custom}});}}>OK</button> </> : <></>}
            {dialogNo === 6 ? <>
            <p>Please Ask Approval For Loan Distripution</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/home')}}>OK</button> </> : <></>}
            {dialogNo === 7 ? <>
            <p>Please Make Sure Payment is More Than Rs.0</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/home')}}>OK</button> </> : <></>}
        </dialog> 
         </>);
}